import {
  UPDATEUSER_DIALOG_OPEN,
  UPDATEUSER_DIALOG_CLOSE
} from "types/actions/update-user-dialog"

export const openUpdateUserDialogFromMembers = data => ({
  type: UPDATEUSER_DIALOG_OPEN,
  open: true,
  openFrom: "members",
  data
})

export const openUpdateUserDialogFromProfile = data => ({
  type: UPDATEUSER_DIALOG_OPEN,
  open: true,
  openFrom: "profile",
  data
})

export const closeUpdateUserDialog = () => {
  return {
    type: UPDATEUSER_DIALOG_CLOSE,
    open: false,
    openFrom: "",
    data: {}
  }
}



// WEBPACK FOOTER //
// ./src/actions/update-user-dialog.js